var React = require('react');

function PlusIcon (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Asset 1"),React.createElement("path",{"d":"M25.68,11.5H15.84V2a2,2,0,0,0-4,0v9.5H2a2,2,0,0,0,0,4h9.84V27a2,2,0,0,0,4,0V15.5h9.84a2,2,0,0,0,0-4Z","key":1})]);
}

PlusIcon.defaultProps = {"width":"27.68","height":"29","viewBox":"0 0 27.68 29"};

module.exports = PlusIcon;

PlusIcon.default = PlusIcon;
